export default "__VITE_ASSET__8499458b__"